import { useState, useEffect } from "react"

/* A window inside the desktop loads its page in an iframe, and that page must
   not draw a desktop of its own inside it, or phone chrome either. The flag
   rides on the URL because the iframe loads the route on its own, with no way
   for the parent to reach in first. */
export const EMBED_PARAM = "embed"

export const embedUrl = route =>
  `${route.replace(/\/*$/, "/")}?${EMBED_PARAM}=1`

export const readEmbeddedNow = () => {
  if (typeof window === "undefined") return false
  try {
    return new URLSearchParams(window.location.search).get(EMBED_PARAM) === "1"
  } catch {
    return false
  }
}

/**
 * True when this page is being rendered inside a desktop window.
 *
 * Starts false for the same reason useIsDesktop does: the server has no query
 * string to read, so the markup it sends is the ordinary page, and the first
 * client render has to agree with it.
 *
 * The two flags settle in the same commit, which is what keeps this from
 * flickering. isDesktop is false on that first render too, so no shell is
 * mounted yet; by the time it turns true this one has as well, and the shell
 * is never built inside the frame at all.
 */
export const useIsEmbedded = () => {
  const [isEmbedded, setIsEmbedded] = useState(false)

  useEffect(() => {
    setIsEmbedded(readEmbeddedNow())
  }, [])

  return isEmbedded
}
